<template>
	<div class="shenming" ref="shenming" v-if="show">
		<div style="height: 100%; width: 100%; overflow: hidden;">
			<h2>{{ En ? 'Declaration' : '严正申明'}}</h2>
			<p v-html="data['content' + En]"></p>
			<div style="height: .36rem"></div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import protal from "@/api/protal";

export default {
	props: {
		showPcShenming: {
			type: Boolean,
			default: true
		}
	},
    name: "display",
    data() {
        return {
            data: '',
			show: false
        };
    },
	watch: {
		showPcShenming(v) {
			if (!v) {
				this.$refs.shenming.style.height = 0
				setTimeout(() => {
					this.show = false
				}, 1000)
			}
		}
	},
	created() {
		protal.getStatementDetail().then(res => {
			this.data = res.data || {}
		})
	}
}
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
	.shenming {
		position: relative;
		z-index: 99999;
		width: 100%;
		background: #EBEBEB;
		height: 330px;
		transition: 1s linear;

		h2 {
			height: 32px;
			font-size: 32px;
			font-family: syn;
			font-weight: 800;
			color: #FC581C;
			line-height: 32px;
			letter-spacing: 1px;
			text-align: center;
			margin-bottom: 24px;
			padding-top: .32rem;
		}

		/deep/ p {
			margin: 0 auto;
			width: 1380px;
			font-size: 16px;
			font-family: syn;
			color: #333333;
			line-height: 24px;
			margin-bottom: 12px;

			a {
				color: #333333 !important;
				font-family: syn;
			}

			&:nth-last-child(1), &:nth-last-child(2) {
				margin-bottom: 0;
			}
		}

		.bottom {
			margin: 0 auto;
			width: 1380px;
			font-size: 16px;
			text-align: right;
			font-family: syn;
			font-weight: bold;
			color: #333333;
			line-height: 24px;
		}
	}
}
@media screen and (max-width: 768px) {
	
}
</style>


// WEBPACK FOOTER //
// src/components/shenming.vue